export const PERFORMANCE_BLOTTER_PREFIX = 'performance/blotter';
/** Legacy default tab id; kept in blotter keys so column state stays stable. */
export const PERFORMANCE_BLOTTER_INSTANCE_ID = 'default-performance';
export const PERFORMANCE_BLOTTER_TABS_ID = 'portfolio/performance-tabs';
export const ALL_SUB_ACCOUNTS_PLACEHOLDER = 'All Sub Accounts';
